export class GetTimeZones {
    public static readonly type: string = '[Location] Get TimeZones';
}

export class GetCountries {
    public static readonly type: string = '[Location] Get Countries';
}
